enum Types {
  NEW_PARTNER_REQUEST = 'NEW_PARTNER_REQUEST',
  NEW_PARTNER_FULFILLED = 'NEW_PARTNER_FULFILLED',
  NEW_PARTNER_REJECTED = 'NEW_PARTNER_REJECTED',

  LDAP_TEST_REQUEST = 'LDAP_TEST_REQUEST',
  LDAP_TEST_FULFILLED = 'LDAP_TEST_FULFILLED',
  LDAP_TEST_REJECTED = 'LDAP_TEST_REJECTED',

  DELETE_PARTNER_REQUEST = 'DELETE_PARTNER_REQUEST',
  DELETE_PARTNER_FULFILLED = 'DELETE_PARTNER_FULFILLED',
  DELETE_PARTNER_REJECTED = 'DELETE_PARTNER_REJECTED',

  GET_CUSTOM_STATE_REQUEST = 'GET_CUSTOM_STATE_REQUEST',
  GET_CUSTOM_STATE_FULFILLED = 'GET_CUSTOM_STATE_FULFILLED',
  GET_CUSTOM_STATE_REJECTED = 'GET_CUSTOM_STATE_REJECTED',

  SAVE_CUSTOM_REQUEST = 'SAVE_CUSTOM_REQUEST',
  SAVE_CUSTOM_FULFILLED = 'SAVE_CUSTOM_FULFILLED',
  SAVE_CUSTOM_REJECTED = 'SAVE_CUSTOM_REJECTED',

  REMOVE_IMAGE_REQUEST = 'REMOVE_IMAGE_REQUEST',
  REMOVE_IMAGE_FULFILLED = 'REMOVE_IMAGE_FULFILLED',
  REMOVE_IMAGE_REJECTED = 'REMOVE_IMAGE_REJECTED',

  EDIT_CUSTOM_REQUEST = 'EDIT_CUSTOM_REQUEST',
  EDIT_CUSTOM_FULFILLED = 'EDIT_CUSTOM_FULFILLED',
  EDIT_CUSTOM_REJECTED = 'EDIT_CUSTOM_REJECTED',

  DELETE_CUSTOM_REQUEST = 'DELETE_CUSTOM_REQUEST',
  DELETE_CUSTOM_FULFILLED = 'DELETE_CUSTOM_FULFILLED',
  DELETE_CUSTOM_REJECTED = 'DELETE_CUSTOM_REJECTED',

  PUBLISH_CUSTOM_REQUEST = 'PUBLISH_CUSTOM_REQUEST',
  PUBLISH_CUSTOM_FULFILLED = 'PUBLISH_CUSTOM_FULFILLED',
  PUBLISH_CUSTOM_REJECTED = 'PUBLISH_CUSTOM_REJECTED',

  EDIT_PARTNER_REQUEST = 'EDIT_PARTNER_REQUEST',
  EDIT_PARTNER_FULFILLED = 'EDIT_PARTNER_FULFILLED',
  EDIT_PARTNER_REJECTED = 'EDIT_PARTNER_REJECTED',

  GET_PARTNER_REQUEST = 'GET_PARTNER_REQUEST',
  GET_PARTNER_FULFILLED = 'GET_PARTNER_FULFILLED',
  GET_PARTNER_REJECTED = 'GET_PARTNER_REJECTED',

  GET_ALL_PARTNERS_REQUEST = 'GET_ALL_PARTNERS_REQUEST',
  GET_ALL_PARTNERS_FULFILLED = 'GET_ALL_PARTNERS_FULFILLED',
  GET_ALL_PARTNERS_REJECTED = 'GET_ALL_PARTNERS_REJECTED',

  GET_ALL_PARTNERS_OPERATOR_REQUEST = 'GET_ALL_PARTNERS_OPERATOR_REQUEST',
  GET_ALL_PARTNERS_OPERATOR_FULFILLED = 'GET_ALL_PARTNERS_OPERATOR_FULFILLED',
  GET_ALL_PARTNERS_OPERATOR_REJECTED = 'GET_ALL_PARTNERS_OPERATOR_REJECTED',

  TOGGLE_BLOCK_PARTNER_REQUEST = 'TOGGLE_BLOCK_PARTNER_REQUEST',
  TOGGLE_BLOCK_PARTNER_FULFILLED = 'TOGGLE_BLOCK_PARTNER_FULFILLED',
  TOGGLE_BLOCK_PARTNER_REJECTED = 'TOGGLE_BLOCK_PARTNER_REJECTED',

  SET_SELECTED_COMPANY = 'SET_SELECTED_COMPANY',
  SET_SELECTED_PARTNER = 'SET_SELECTED_PARTNER',

  GET_ALL_PARTNER_SERVERS_REQUEST = 'GET_ALL_PARTNER_SERVERS_REQUEST',
  GET_ALL_PARTNER_SERVERS_FULFILLED = 'GET_ALL_PARTNER_SERVERS_FULFILLED',
  GET_ALL_PARTNER_SERVERS_REJECTED = 'GET_ALL_PARTNER_SERVERS_REJECTED',

  START_PARTNER_SERVERS_REQUEST = 'START_PARTNER_SERVERS_REQUEST',
  START_PARTNER_SERVERS_FULFILLED = 'START_PARTNER_SERVERS_FULFILLED',
  START_PARTNER_SERVERS_REJECTED = 'START_PARTNER_SERVERS_REJECTED',

  STOP_PARTNER_SERVERS_REQUEST = 'STOP_PARTNER_SERVERS_REQUEST',
  STOP_PARTNER_SERVERS_FULFILLED = 'STOP_PARTNER_SERVERS_FULFILLED',
  STOP_PARTNER_SERVERS_REJECTED = 'STOP_PARTNER_SERVERS_REJECTED',

  PUBLISH_PARTNER_SERVERS_REQUEST = 'PUBLISH_PARTNER_SERVERS_REQUEST',
  PUBLISH_PARTNER_SERVERS_FULFILLED = 'PUBLISH_PARTNER_SERVERS_FULFILLED',
  PUBLISH_PARTNER_SERVERS_REJECTED = 'PUBLISH_PARTNER_SERVERS_REJECTED',

  CLONE_PARTNER_REQUEST = 'CLONE_PARTNER_REQUEST',
  CLONE_PARTNER_FULFILLED = 'CLONE_PARTNER_FULFILLED',
  CLONE_PARTNER_REJECTED = 'CLONE_PARTNER_REJECTED',

  CHANGE_AD_PASSWORD_REQUEST = 'CHANGE_AD_PASSWORD_REQUEST',
  CHANGE_AD_PASSWORD_FULFILLED = 'CHANGE_AD_PASSWORD_FULFILLED',
  CHANGE_AD_PASSWORD_REJECTED = 'CHANGE_AD_PASSWORD_REJECTED',

  GET_LDAP_TYPE_REPORT_FULFILLED = 'GET_LDAP_TYPE_REPORT_FULFILLED',
  GET_LDAP_TYPE_REPORT_REJECTED = 'GET_LDAP_TYPE_REPORT_REJECTED',
  GET_LDAP_TYPE_REPORT_REQUEST = 'GET_LDAP_TYPE_REPORT_REQUEST',

  GET_SSO_REPORT_FULFILLED = 'GET_SSO_REPORT_FULFILLED',
  GET_SSO_REPORT_REJECTED = 'GET_SSO_REPORT_REJECTED',
  GET_SSO_REPORT_REQUEST = 'GET_SSO_REPORT_REQUEST',

  GET_NEW_FRONT_REPORT_FULFILLED = 'GET_NEW_FRONT_REPORT_FULFILLED',
  GET_NEW_FRONT_REPORT_REJECTED = 'GET_NEW_FRONT_REPORT_REJECTED',
  GET_NEW_FRONT_REPORT_REQUEST = 'GET_NEW_FRONT_REPORT_REQUEST',

  GET_PARTNER_PROVIDER_TYPE_REPORT_FULFILLED = 'GET_PARTNER_PROVIDER_TYPE_REPORT_FULFILLED',
  GET_PARTNER_PROVIDER_TYPE_REPORT_REJECTED = 'GET_PARTNER_PROVIDER_TYPE_REPORT_REJECTED',
  GET_PARTNER_PROVIDER_TYPE_REPORT_REQUEST = 'GET_PARTNER_PROVIDER_TYPE_REPORT_REQUEST',

  EXPORT_PARTNER_SUMMARY_REQUEST = 'EXPORT_PARTNER_SUMMARY_REQUEST',
  EXPORT_PARTNER_SUMMARY_FULFILLED = 'EXPORT_PARTNER_SUMMARY_FULFILLED',
  EXPORT_PARTNER_SUMMARY_REJECTED = 'EXPORT_PARTNER_SUMMARY_REJECTED',

  PUBLISH_IMAGE_PARTNER_REQUEST = 'PUBLISH_IMAGE_PARTNER_REQUEST',
  PUBLISH_IMAGE_PARTNER_FULFILLED = 'PUBLISH_IMAGE_PARTNER_FULFILLED',
  PUBLISH_IMAGE_PARTNER_REJECTED = 'PUBLISH_IMAGE_PARTNER_REJECTED',

  BLOCK_SERVER_PARTNER_ACTIONS_REQUEST = 'BLOCK_SERVER_PARTNER_ACTIONS_REQUEST',
  BLOCK_SERVER_PARTNER_ACTIONS_FULFILLED = 'BLOCK_SERVER_PARTNER_ACTIONS_FULFILLED',
  BLOCK_SERVER_PARTNER_ACTIONS_REJECTED = 'BLOCK_SERVER_PARTNER_ACTIONS_REJECTED',

  UNBLOCK_SERVER_PARTNER_ACTIONS_REQUEST = 'UNBLOCK_SERVER_PARTNER_ACTIONS_REQUEST',
  UNBLOCK_SERVER_PARTNER_ACTIONS_FULFILLED = 'UNBLOCK_SERVER_PARTNER_ACTIONS_FULFILLED',
  UNBLOCK_SERVER_PARTNER_ACTIONS_REJECTED = 'UNBLOCK_SERVER_PARTNER_ACTIONS_REJECTED',

  GET_INSTANCES_BY_USAGE_REQUEST = 'GET_INSTANCES_BY_USAGE_REQUEST',
  GET_INSTANCES_BY_USAGE_FULFILLED = 'GET_INSTANCES_BY_USAGE_FULFILLED',
  GET_INSTANCES_BY_USAGE_REJECTED = 'GET_INSTANCES_BY_USAGE_REJECTED',

  GET_LEAKED_CREDENTIAL_USERS_REQUEST = 'GET_LEAKED_CREDENTIAL_USERS_REQUEST',
  GET_LEAKED_CREDENTIAL_USERS_FULFILLED = 'GET_LEAKED_CREDENTIAL_USERS_FULFILLED',
  GET_LEAKED_CREDENTIAL_USERS_REJECTED = 'GET_LEAKED_CREDENTIAL_USERS_REJECTED',

  GET_LEAKED_CREDENTIAL_USERS_CLIENTS_REQUEST = 'GET_LEAKED_CREDENTIAL_USERS_CLIENTS_REQUEST',
  GET_LEAKED_CREDENTIAL_USERS_CLIENTS_FULFILLED = 'GET_LEAKED_CREDENTIAL_USERS_CLIENTS_FULFILLED',
  GET_LEAKED_CREDENTIAL_USERS_CLIENTS_REJECTED = 'GET_LEAKED_CREDENTIAL_USERS_CLIENTS_REJECTED',

  RESET_PASSWORD_LEAKED_CREDENTIALS_REQUEST = 'RESET_PASSWORD_LEAKED_CREDENTIALS_REQUEST',
  RESET_PASSWORD_LEAKED_CREDENTIALS_FULFILLED = 'RESET_PASSWORD_LEAKED_CREDENTIALS_FULFILLED',
  RESET_PASSWORD_LEAKED_CREDENTIALS_REJECTED = 'RESET_PASSWORD_LEAKED_CREDENTIALS_REJECTED',
}

export default Types;
